import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      page: 1,
      pageSize: 10,
      totalCount: 0,
      siteList: [],
      name: "",
      committee: [{
        label: '教学改革专业委员会',
        value: '1'
      }, {
        label: '技能开发专业委员会',
        value: '2'
      }, {
        label: '校企合作专业委员会',
        value: '3'
      }, {
        label: '国际合作专业委员会',
        value: '4'
      }, {
        label: '信息化专业委员会',
        value: '5'
      }, {
        label: '师资建设专业委员会',
        value: '6'
      }],
      committeeType: '',
      isCommittee: ''
    };
  },
  components: {},
  created: function created() {
    this.getSessionStorage();
    this.getCommitteeList();
  },
  methods: {
    goLook: function goLook(id) {
      this.$router.push({
        name: "committeeDetail",
        params: {
          committeeId: id
        }
      });
    },
    handleSelectionChange: function handleSelectionChange() {},
    handleSizeChange: function handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getCommitteeList();
    },
    onPageChangeHandler: function onPageChangeHandler(val) {
      this.page = val;
      this.getCommitteeList();
    },
    season: function season() {
      this.page = 1;
      this.getCommitteeList();
    },
    // getPilotList(){},
    getCommitteeList: function getCommitteeList() {
      var that = this;
      this.$http.post("/api/XOrg/Committee/getCommitteeList", {
        name: that.name,
        isCommittee: that.isCommittee,
        committeeType: that.committeeType,
        PageSize: that.pageSize,
        page: that.page
      }).then(function (rst) {
        that.siteList = rst.list;
        that.page = rst.pagination.pageIndex;
        that.pageSize = rst.pagination.pageSize;
        that.totalCount = rst.pagination.totalCount; // 参数存储本地缓存

        sessionStorage.setItem("wlx_committee_name", that.name);
        sessionStorage.setItem("wlx_committee_isCommittee", that.isCommittee);
        sessionStorage.setItem("wlx_committee_committeeType", that.committeeType);
        sessionStorage.setItem("wlx_committee_page", that.page);
        sessionStorage.setItem("wlx_committee_pageSize", that.pageSize);
      });
    },
    // 获取网页缓存信息
    getSessionStorage: function getSessionStorage() {
      // 获取网页缓存信息
      var name = sessionStorage.getItem("wlx_committee_name");
      var isCommittee = sessionStorage.getItem("wlx_committee_isCommittee");
      var committeeType = sessionStorage.getItem("wlx_committee_committeeType");
      var page = sessionStorage.getItem("wlx_committee_page");
      var pageSize = sessionStorage.getItem("wlx_assessmentApplye_pageSize");

      if (name != null && name != undefined && name != "null" && name != 'undefined') {
        this.name = name;
      }

      if (isCommittee != null && isCommittee != undefined && isCommittee != "null" && isCommittee != 'undefined') {
        this.isCommittee = isCommittee;
      }

      if (committeeType != null && committeeType != undefined && committeeType != "null" && committeeType != 'undefined') {
        this.committeeType = committeeType;
      }

      if (page != null && page != undefined) {
        this.page = page;
      }

      if (pageSize != null && pageSize != undefined) {
        this.pageSize = pageSize;
      }
    }
  }
};